import { IntlShape } from 'react-intl';

import { ChannelProgramDays } from '../../types';

export const getDailyTitleMap = (intl: IntlShape): Record<ChannelProgramDays, string> => ({
    Today: intl.formatMessage({
        id: 'features.channel-program.1dd1c5fb7f25cd41b291d43a89e3aefd',
        defaultMessage: 'Today',
        description: 'Текст сегодня в телепрограмме',
    }),
    Yesterday: intl.formatMessage({
        id: 'features.channel-program.ebfe9ce86e6e9fb953aa7a25b59c1956',
        defaultMessage: 'Yesterday',
        description: 'Текст вчера в телепрограмме',
    }),
    Tomorrow: intl.formatMessage({
        id: 'features.channel-program.ff9eb8bd8c927da073cea632f294e23b',
        defaultMessage: 'Tomorrow',
        description: 'Текст завтра в телепрограмме',
    }),
});
